export * from './CommentRectXIcon';
export * from './CommentRectXIcon16Light';
export * from './CommentRectXIcon16Regular';
export * from './CommentRectXIcon16Solid';
export * from './CommentRectXIcon20Light';
export * from './CommentRectXIcon20Regular';
export * from './CommentRectXIcon20Solid';
export * from './CommentRectXIcon24Regular';
export * from './CommentRectXIcon24Solid';
export * from './CommentRectXIcon32Regular';
export * from './CommentRectXIcon64Regular';
